import React from 'react'
import { SocialShareBlack } from 'components/SocialShare/SocialShare'
import WhatAboutUs from 'components/WhatAboutUs/WhatAboutUs'
import SketchizeInfo from 'components/SketchizeInfo/SketchizeInfo'
import logo from 'assets/images/footer-logo.svg'

export default class Footer extends React.Component {
  render() {
    return (
      <footer className="footer">

        <WhatAboutUs />

        <div className="inn">

          <div id="scrollMeToMoon" className="scroll-top-btn">
            <span className="sketch-scroll-top"></span>
          </div>

          <div className="logo">
            <a href="http://sketchize.com/">
              <img src={logo} alt="" />
            </a>
          </div>

          <SocialShareBlack />

          <SketchizeInfo />

          <p className="copyright">Sketchize licensed under SIL OFL 1.1 · Code licensed under MIT License · Documentation licensed under CC BY 3.0</p>

        </div>{/* .inn */}

      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js